"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HighlightedCode_1 = require("./HighlightedCode");
const serializer = new XMLSerializer();
function SearchResult({ node }) {
    return react_1.default.createElement(HighlightedCode_1.HighlightedCode, { language: 'xml' }, serializer.serializeToString(node));
}
exports.default = SearchResult;
